import React from 'react'

import { SpaceProps } from '../../../themes'
import { Container, Label, RequiredBadge } from './styles'

export interface FieldLabelProps extends SpaceProps {
  /**
   * Field id
   */
  id?: string

  /**
   * Class name
   */
  className?: string

  /**
   * Is required field
   */
  required?: boolean

  /**
   * Label children
   */
  children: React.ReactNode
}

export const FieldLabel = ({
  id,
  required,
  children,
  ...spaceProps
}: FieldLabelProps) => {
  return (
    <Container {...spaceProps}>
      <Label htmlFor={id}>{children}</Label>
      {required && <RequiredBadge>必須</RequiredBadge>}
    </Container>
  )
}
